module.exports = __webpack_public_path__ + "img/blue_047.813cef3f.png";